import React from "react";

function Title1({ children, className }: TitlePropsType) {
  return <h1 className={`text-6xl font-bold  ${className}`}>{children}</h1>;
}

export default Title1;
type TitlePropsType = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>;
